import axios, { AxiosError } from "axios";

import queryString from "query-string";
const URL_GIA_DAT = process.env.REACT_APP_GD_URL;

export const headers = (
  type = "application/json; charset=utf-8"
): Readonly<Record<string, string | boolean>> => {
  const token = window.localStorage.getItem("accessToken");
  return {
    Accept: "application/json",
    "Content-Type": type,
    "Access-Control-Allow-Credentials": true,
    "X-Requested-With": "XMLHttpRequest",
    "x-api-key": process.env.REACT_APP_GD_API_KEY ?? "",
    Authorization: `Bearer ${token}`,
  };
};

const axiosInstance = axios.create({
  baseURL: URL_GIA_DAT,
  headers: headers(),
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error: AxiosError) => {
    const obj: any = error.response && error.response.data;
    let message = "";
    if (obj) {
      if (obj.title) message = obj.title;
      else if (obj.message) message = obj.message;
      else message = obj;
    }
    return Promise.reject(message);
  }
);

const axiosFileUpload = axios.create({
  baseURL: URL_GIA_DAT,
  headers: headers("multipart/form-data"),
  paramsSerializer: {
    encode: (params: any) => queryString.stringify(params),
  },
});

axiosFileUpload.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error: AxiosError) =>
    Promise.reject(
      (error.response && error.response.data) || "Something went wrong"
    )
);

export { axiosFileUpload };

export default axiosInstance;
